import { Component, OnInit,ViewChild } from '@angular/core';
import { KitchenStockRequirementService } from 'app/shared/services/kitchen-stock-requirement.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DialogService } from 'app/shared/services/dialog.service';
import { HttpErrorResponse } from '@angular/common/http';
import { NbThemeService } from '@nebular/theme';
import { AuthService } from 'app/shared/services/auth.service';
import { EnvService } from '../../../shared/services/env.service';


@Component({
  selector: 'ngx-stock-requirement-list',
  templateUrl: './stock-requirement-list.component.html',
  styleUrls: ['./stock-requirement-list.component.scss']
})
export class StockRequirementListComponent implements OnInit {

 
  displayedColumns: string[] = ['DocNo','DocDate', 'GrandTotal','Status','CreatedBy','Action'];
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  dataSource :MatTableDataSource<any>
  searchKey : string;
  isDark: boolean = false;

  item : any[];

  crud_access = {
    read: null,
    create: null,
    approve: null,
    delete: null,
   };
  
  statusCode: number;

  constructor(private kitchenStockRequirementService : KitchenStockRequirementService,
              private dialogService : DialogService,
              private router : Router, 
              private toastr: ToastrService,
              private route: ActivatedRoute,
              private themeService: NbThemeService,
              private authService: AuthService,
              private env: EnvService
              ) { }

  ngOnInit() {
    this.getAllItems();
    this.getControlPermissions();

    this.themeService.onThemeChange()
    .subscribe(themeName =>{
         this.isDark  = themeName.name ==='dark' ? true : false;
       });
  }

  getControlPermissions(){
    var data = [];
     data =  this.authService.controlPermissionArray.filter((el)=>{
      return el.moduleCode ==='KS'
    });

    if(data.length > 0){
      this.crud_access.read = data[0].read;
      this.crud_access.create = data[0].create;
      this.crud_access.approve = data[0].approve;
      this.crud_access.delete = data[0].delete;
    }
  }



  newButtonClick() {
      this.kitchenStockRequirementService.orderItems = [];
      this.router.navigate(['../add-stock-requirement'],{relativeTo : this.route});
     
   }

   veiwButtonClick(documentNo){
    this.router.navigate(['../stock-requirement'],{queryParams : {'documentNo':documentNo},relativeTo : this.route}); 
  }
  
getAllItems(){
    this.kitchenStockRequirementService.getAll()
     .subscribe(
        (data) => {
                  this.item = data;
                  this.dataSource = new  MatTableDataSource (this.item );  
                  this.dataSource.sort = this.sort;
                  this.dataSource.paginator = this.paginator;  
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                 });  
       
     }

        

      applyFilter(){
        this.dataSource.filter =this.searchKey.trim().toLowerCase();

      }
      onSearchClear(){
        this.searchKey = "";
        this.applyFilter();
      }



   

}
